import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from "../../app/constants"

const privacyNoticeState = () => ({
    "collection-agency":{
        header : 'Privacy notice',
        text : [
            "The Collection Agency and Debt Management Agency Licensing service collects your personal information (name, address, email, phone, relevant criminal history, business licence suspension history, and work history) as allowed by the Freedom of Information and Protection of Privacy Act and the Collection and Debt Management Agencies Act.",
            "We use your personal information to: <br /><ul><li>Determine your eligibility for a licence</li><li>Process your application to prepare to issue your licence</li><li>Contact you if necessary</li><li>Process your payment and issue a receipt</li></ul>",
            "We use and disclose your personal information for the purposes described above. We may only use or disclose your information for another purpose if we are authorized by law to do so, or if we obtain your consent.",
            "To read more about how government respects your privacy when interacting with us review our full <a href='https://beta.novascotia.ca/privacy' target='_blank' rel='noreferrer'>privacy statement (opens in a new tab)</a>. For questions about how your personal information is handled by the Business Licensing program, you may contact Business Licensing at 902-424-5552 or reglicensing@novascotia.ca."
        ],
        navigation : {
            next : ROUTE_PATH.ELIGIBILITY_CONFIRMATION,
            previous : '/'
        },
        navigationRenewal : {
            next : ROUTE_PATH.NS_LOGIN,
            previous : '/'
        },
        privacyNoticeAgree : false
    },
    "debt-management-agency" : {
        header : 'Privacy notice',
        text : [
            "The Collection Agency and Debt Management Agency Licensing service collects your personal information (name, address, email, phone, relevant criminal history, business licence suspension history, and work history) as allowed by the Freedom of Information and Protection of Privacy Act and the Collection and Debt Management Agencies Act.",
            "We use your personal information to: <br /><ul><li>Determine your eligibility for a licence</li><li>Process your application to prepare to issue your licence</li><li>Contact you if necessary</li><li>Process your payment and issue a receipt</li></ul>",
            "We use and disclose your personal information for the purposes described above. We may only use or disclose your information for another purpose if we are authorized by law to do so, or if we obtain your consent.",
            "To read more about how government respects your privacy when interacting with us review our full <a href='https://beta.novascotia.ca/privacy' target='_blank' rel='noreferrer'>privacy statement (opens in a new tab)</a>. For questions about how your personal information is handled by the Business Licensing program, you may contact Business Licensing at 902-424-5552 or reglicensing@novascotia.ca."
        ],
        navigation : {
            next : ROUTE_PATH.ELIGIBILITY_CONFIRMATION,
            previous : '/'
        },
        navigationRenewal : {
            next : ROUTE_PATH.NS_LOGIN,
            previous : '/'
        },
        privacyNoticeAgree : false
    },
    "collector" : {
        header : 'Privacy notice',
        text : [
            "The Collection Agency and Debt Management Agency Licensing service collects your personal information (name, address, email, phone, relevant criminal history, business licence suspension history, and work history) as allowed by the Freedom of Information and Protection of Privacy Act and the Collection and Debt Management Agencies Act.",
            "We use your personal information to: <br /><ul><li>Determine your eligibility for a licence</li><li>Process your application to prepare to issue your licence</li><li>Contact you if necessary</li><li>Process your payment and issue a receipt</li></ul>",
            "We use and disclose your personal information for the purposes described above. We may only use or disclose your information for another purpose if we are authorized by law to do so, or if we obtain your consent.",
            "To read more about how government respects your privacy when interacting with us review our full <a href='https://beta.novascotia.ca/privacy' target='_blank' rel='noreferrer'>privacy statement (opens in a new tab)</a>. For questions about how your personal information is handled by the Business Licensing program, you may contact Business Licensing at 902-424-5552 or reglicensing@novascotia.ca."
        ],
        navigation : {
            next : ROUTE_PATH.NS_LOGIN,
            previous : '/'
        },
        privacyNoticeAgree : false
    }
})

const privacyNoticeSlice = createSlice({
    name: 'privacyNotice',
    initialState : privacyNoticeState(),
    reducers : {
        setPrivacyNoticeAgree(state, action) { 
            state.privacyNoticeAgree = true
        }
    }
})

export const {setPrivacyNoticeAgree} = privacyNoticeSlice.actions
export default privacyNoticeSlice.reducer
